import { useMemo } from 'react';
import { WorkspaceObjectRole, WorkspaceObjectType } from '@/enums';
import {
  UserObjectAccessContext,
} from './Context';
import { useObjectAccessContext } from './hooks';

type Props = {
  selectedRole: WorkspaceObjectRole;
} & IUserId
  & ChildrenProps;

export const UserObjectAccessContainer = (props: Props) => {
  const { object } = useObjectAccessContext();

  const roles = useMemo(() => {
    if (object.typeId === WorkspaceObjectType.Folder) {
      return [WorkspaceObjectRole.Viewer];
    } else {
      return [
        WorkspaceObjectRole.Collaborator,
        WorkspaceObjectRole.Viewer,
      ];
    }
  }, [
    object.typeId,
  ]);

  const value = {
    roles,
    selectedRole: props.selectedRole,
    userId: props.userId,
  };

  return (
    <UserObjectAccessContext.Provider value={value}>
      {props.children}
    </UserObjectAccessContext.Provider>
  );
};

export default UserObjectAccessContainer;